import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export function Panel({
  title,
  actions,
  children,
  bleed = false,
  className,
}: {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  /** Sin padding interior: para tablas que llegan al borde. */
  bleed?: boolean;
  className?: string;
}) {
  return (
    <section
      className={cn(
        "overflow-hidden rounded-lg border border-line bg-surface",
        className,
      )}
    >
      {(title || actions) && (
        <header className="flex items-center justify-between gap-3 border-b border-line-2 px-4 py-3">
          <h2 className="text-ui font-semibold">{title}</h2>
          {actions && <div className="flex items-center gap-1.5">{actions}</div>}
        </header>
      )}
      <div className={bleed ? "" : "p-4"}>{children}</div>
    </section>
  );
}
